import { createTheme,  } from "@mui/material/styles";
export const switchTheme = createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            // Thumb color when checked
            "&.Mui-checked": {
              color: "green",
              "& + .MuiSwitch-track": {
                backgroundColor: "green",
              },
            },
            // Thumb color when unchecked
            color: "red", // This is the thumb color when unchecked
          },
          track: {
            backgroundColor: "red", // Track color when unchecked
          },
        },
      },
    },
  });
  